import React from 'react'
import { BookMarked } from 'lucide-react'
import ContentRenderer from '../../../components/ContentRenderer'
import { cardToContentItems } from '../lib/cardToContentItem'
import { genId } from '../lib/id'
import type { RichCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

// Thẻ nội dung kế thừa: giữ nguyên ContentItem[] từ chương trình cũ,
// render bằng đúng ContentRenderer hiện hành (không mất định dạng/công thức).
const Editor: React.FC<CardEditorProps> = ({ card }) => {
  const c = card as RichCard
  return (
    <div className="space-y-2">
      <div className="p-3 rounded-lg bg-sky-50 border border-sky-100 text-sky-700 text-sm">
        Nội dung kế thừa từ chương trình hiện có: <strong>{c.items?.length ?? 0} khối</strong>.
      </div>
      {c.sourceRef && <p className="text-xs text-gray-400 break-all">Nguồn: {c.sourceRef}</p>}
      <p className="text-xs text-gray-400">
        Thẻ này giữ nguyên nội dung gốc để bảo toàn định dạng. Có thể xoá thẻ và thêm thẻ mới nếu muốn biên tập lại.
      </p>
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const items = cardToContentItems(card)
  if (!items || items.length === 0) {
    return (
      <div className="p-4 rounded-lg bg-gray-50 border border-dashed border-gray-200 text-gray-400 text-sm text-center">
        Chưa có nội dung kế thừa.
      </div>
    )
  }
  return <ContentRenderer content={items} />
}

export const richCardDef: CardDef = {
  type: 'rich',
  label: 'Nội dung kế thừa',
  description: 'Bài gốc từ chương trình hiện có',
  icon: BookMarked,
  color: 'bg-sky-50 text-sky-600',
  createDefault: (): RichCard => ({ id: genId(), type: 'rich', items: [] }),
  Editor,
  Preview,
}
